import React, { useEffect, useState } from "react";
import {
    DKLabel,
    DKButton,
    DKInput,
    showToast,
    TOAST_TYPE,
    showLoader,
    removeLoader,
    INPUT_VIEW_DIRECTION
} from "deskera-ui-library";
import { INPUT_TYPE } from "../constants/Constant";
import { Countries, COUNTRY } from "../constants/CountryConstant";
import TenantManager from "../managers/TenantManager";
import CompanyDetailService from "../services/CompanyDetailService";
import { TENANT, TenantService } from "../managers/TenantManagerService";
import Utility from "../utility/Utility";

function SetupOrganization(props) {
    const [country, setCountry] = useState({
        id: "country",
        title: "Country",
        options: Countries.map(c => c.label),
        value: [],
        required: true,
        invalid: false,
        readOnly: false
    });

    useEffect(() => {
        const tenatDetails = TenantManager.getTenantDetails();
        const tenantCountry = !Utility.isEmpty(tenatDetails) ? tenatDetails.country : "";
        if (!Utility.isEmpty(tenantCountry)) {
            let selectedCountry = Countries.find(x=> x.value === tenantCountry);
            if(!Utility.isEmpty(selectedCountry)) {
                let index = country.options.findIndex(x=> x === selectedCountry.label);
                if(index != -1) {
                    setCountry({
                      ...country,
                      value: [index],
                      invalid: index != -1,
                      readOnly: true
                    });
                }
            }
        }
    },[]);

    const saveCountry = () => {
        if (country.value.length === 0) {
            setCountry({
                ...country,
                invalid: true
            });
            return;
        }

        const tenantData = TenantManager.getPeopleTenantData();
        if (tenantData && tenantData.status === "OK") {
            const countryObj = Countries.find((c, i) => i === country.value[0]);
            const params = CompanyDetailService.getTenantSetupParams(tenantData.tenant, countryObj);

            showLoader("Please wait...");
            CompanyDetailService.updateCompanyDetail(params).then(
                (response) => {
                    removeLoader();
                    if (response && response.status === "OK") {
                        TenantService.set(TENANT.COUNTRY_CODE, countryObj.value);
                        TenantService.set(TENANT.CURRENCY_CODE, countryObj.currencyCode);
                        props.onComplete();
                        window.location.reload();
                    }
                }, (error) => {
                    removeLoader();
                    showToast("Internal Server Error", TOAST_TYPE.FAILURE);
                }
            );
        }
    }

    return (
        <div className="transparent-background">
            <div className="popup-window" style={{ padding: "24px", top: "48%", maxWidth: "375px", overflow: "visible" }}>
                <div className="popup-wrapper parent-width parent-height">
                    <div className="row justify-content-between pb-l">
                        <DKLabel className="fs-xl fw-m" text={"Setup Organization"} />
                        <DKButton
                            title={"Continue"}
                            className={"dk-bg-button text-white fs-r"}
                            onClick={() => {
                                saveCountry();
                            }}
                        />
                    </div>
                    <div className="pt-xl pb-s">
                        <DKInput
                            title={country.title}
                            type={INPUT_TYPE.SELECT}
                            direction={INPUT_VIEW_DIRECTION.VERTICAL}
                            options={country.options}
                            value={country.value}
                            required={country.required}
                            canValidate={country.invalid}
                            onChange={(value) => {
                                setCountry({
                                    ...country,
                                    value: value,
                                    invalid: value.length === 0
                                });
                            }}
                            readOnly={country.readOnly}
                        />
                    </div>
                </div>
            </div>
        </div>
    )
}

export default SetupOrganization;
